<template>
    <div dir="rtl" class="mr-8 px-4 sm:px-6 lg:px-8">
        <div class="sm:flex sm:items-center">
            <div class="sm:flex-auto">
                <h1 class="text-xl font-semibold text-gray-900">تعديل اعدادات التطبيق</h1>
                <p class="mt-2 text-sm text-gray-700"></p>
            </div>
        </div>
        <div class="mt-3 col-span-6 sm:col-span-3">
            <label for="last-name" class="block text-lg font-medium text-gray-700">تعديل رسالة حفظة</label>
            <input v-model="mesHafadh" type="text" name="last-name" id="last-name" autocomplete="family-name"
                class="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
        </div>

        <div class="mt-3 col-span-6 sm:col-span-3">
            <label for="last-name" class="block text-lg font-medium text-gray-700">تعديل رابط دعم حفظة</label>
            <input v-model="hafadhLink" type="text" name="last-name" id="last-name" autocomplete="family-name"
                class="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
        </div>

        <div class="mt-6 grid grid-cols-1 gap-6 sm:grid-cols-2">
            <div>
                <label class="block text-lg font-medium text-gray-700">تفعيل التحديث الإجباري (Android)</label>
                <div class="mt-2 flex items-center">
                    <input id="force-android" type="checkbox" v-model="forceAndroid"
                           class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded">
                    <label for="force-android" class="ml-2 block text-sm text-gray-700">إجبار مستخدمي Android على التحديث</label>
                </div>
            </div>
            <div>
                <label class="block text-lg font-medium text-gray-700">تفعيل التحديث الإجباري (iOS)</label>
                <div class="mt-2 flex items-center">
                    <input id="force-ios" type="checkbox" v-model="forceIos"
                           class="h-4 w-4 text-blue-600 focus:ring-blue-500 border-gray-300 rounded">
                    <label for="force-ios" class="ml-2 block text-sm text-gray-700">إجبار مستخدمي iPhone على التحديث</label>
                </div>
            </div>
        </div>

        <div class="mt-6 grid grid-cols-1 gap-6 sm:grid-cols-2">
            <div>
                <label class="block text-lg font-medium text-gray-700">أقل نسخة Android مسموح بها</label>
                <input v-model="minVersionAndroid" type="text" placeholder="مثال: 1.4.0"
                    class="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                <p class="mt-1 text-sm text-gray-500">سيُطلب من المستخدمين الأقدم من هذه النسخة التحديث.</p>
            </div>
            <div>
                <label class="block text-lg font-medium text-gray-700">أقل نسخة iOS مسموح بها</label>
                <input v-model="minVersionIos" type="text" placeholder="مثال: 1.4.0"
                    class="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                <p class="mt-1 text-sm text-gray-500">اترك الحقل فارغاً لتعطيل التحقق من النسخة.</p>
            </div>
        </div>

        <!-- Agora Configuration Section -->
        <div class="mt-8 border-t border-gray-200 pt-6">
            <h2 class="text-lg font-semibold text-gray-900 mb-4">إعدادات Agora</h2>
            <div class="mt-6 grid grid-cols-1 gap-6 sm:grid-cols-2">
                <div>
                    <label class="block text-lg font-medium text-gray-700">Agora App ID</label>
                    <input 
                        v-model="agoraAppId" 
                        type="text" 
                        @focus="handleAgoraAppIdFocus"
                        @blur="handleAgoraAppIdBlur"
                        class="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                    <p class="mt-1 text-sm text-gray-500">معرف تطبيق Agora الخاص بالفرع. (يتم عرض آخر 4 خانات فقط بعد الحفظ)</p>
                </div>
                <div>
                    <label class="block text-lg font-medium text-gray-700">Agora App Certificate</label>
                    <input 
                        v-model="agoraAppCertificate" 
                        type="text" 
                        @focus="handleAgoraAppCertificateFocus"
                        @blur="handleAgoraAppCertificateBlur"
                        class="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                    <p class="mt-1 text-sm text-gray-500">شهادة تطبيق Agora (للاستخدام في Backend فقط). (يتم عرض آخر 4 خانات فقط بعد الحفظ)</p>
                </div>
                <div>
                    <label class="block text-lg font-medium text-gray-700">Agora Expiration Time (ثواني)</label>
                    <input v-model="agoraExpTime" type="number" placeholder="مثال: 1800"
                        class="mt-1 focus:ring-blue-500 focus:border-blue-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md" />
                    <p class="mt-1 text-sm text-gray-500">وقت انتهاء صلاحية Token بالثواني (افتراضي: 1800 = 30 دقيقة).</p>
                </div>
            </div>
        </div>

        <div dir="ltr" class="mt-10"> <button class="button" type="submit" @click="editSetting()">
                تعديل الاعدادات
            </button>
        </div>
        <div dir="ltr" class="mt-5">
            <button class="button" type="button" @click="triggerDailyTracker">
                تشغيل المتتبع اليومي
            </button>
        </div>
    </div>



</template>


<script>
import url from '@/url';
import axios from 'axios';
import { defineComponent } from 'vue';

export default defineComponent({
    data() {
        return {
            mesHafadh: '',
            hafadhLink: '',
            forceAndroid: false,
            forceIos: false,
            minVersionAndroid: '',
            minVersionIos: '',
            agoraAppId: '',
            agoraAppCertificate: '',
            agoraExpTime: '1800',
            // Store original values for comparison
            originalAgoraAppId: '',
            originalAgoraAppCertificate: '',
        }
    },
    computed: {
        // Display masked values (last 4 characters only)
        displayAgoraAppId() {
            if (!this.agoraAppId || this.agoraAppId.length <= 4) {
                return this.agoraAppId;
            }
            // If value starts with ******, it's already masked, return as is
            if (this.agoraAppId.startsWith('******')) {
                return this.agoraAppId;
            }
            // Show last 4 characters, mask the rest
            const last4 = this.agoraAppId.slice(-4);
            return '******' + last4;
        },
        displayAgoraAppCertificate() {
            if (!this.agoraAppCertificate || this.agoraAppCertificate.length <= 4) {
                return this.agoraAppCertificate;
            }
            // If value starts with ******, it's already masked, return as is
            if (this.agoraAppCertificate.startsWith('******')) {
                return this.agoraAppCertificate;
            }
            // Show last 4 characters, mask the rest
            const last4 = this.agoraAppCertificate.slice(-4);
            return '******' + last4;
        },
    },
    mounted() {
        this.getInfo();
    },
    methods: {
        getInfo() {
            // Get tenant_id from JWT token
            let tenantId = null;
            try {
                const token = localStorage.getItem('token');
                if (token) {
                    const payload = JSON.parse(atob(token.split('.')[1]));
                    tenantId = payload.tenantId || payload.tenant_id || null;
                }
            } catch (e) {
                console.warn('Could not extract tenantId from token:', e);
            }

            // Build URL with tenantId as query parameter
            let urlWithParams = url.get_config;
            if (tenantId) {
                urlWithParams += `?tenantId=${encodeURIComponent(tenantId)}`;
            }

            axios.get(process.env.VUE_APP_SERVICE_URL + urlWithParams)
                .then(response => {
                    if (response.status == 200) {
                        response.data.result.data.forEach((item) => {
                            console.log(item);
                            if (item.code == "ADMIN_MESSAGE") {
                                this.mesHafadh = item.value;
                            }
                            else if (item.code == "PAYMENT_LINK") {
                                this.hafadhLink = item.value;
                            } else if (item.code == "FORCE_UPDATE_ANDROID") {
                                this.forceAndroid = String(item.value).toLowerCase() === 'true';
                            } else if (item.code == "FORCE_UPDATE_IOS") {
                                this.forceIos = String(item.value).toLowerCase() === 'true';
                            } else if (item.code == "MIN_VERSION_ANDROID") {
                                this.minVersionAndroid = item.value;
                            } else if (item.code == "MIN_VERSION_IOS") {
                                this.minVersionIos = item.value;
                            } else if (item.code == "AGORA_APP_ID") {
                                this.agoraAppId = item.value;
                                this.originalAgoraAppId = item.value; // Store original for comparison
                                // Mask the value for display (show last 4 only)
                                if (item.value && item.value.length > 4) {
                                    this.agoraAppId = '******' + item.value.slice(-4);
                                }
                            } else if (item.code == "AGORA_APP_CERTIFICATE") {
                                this.agoraAppCertificate = item.value;
                                this.originalAgoraAppCertificate = item.value; // Store original for comparison
                                // Mask the value for display (show last 4 only)
                                if (item.value && item.value.length > 4) {
                                    this.agoraAppCertificate = '******' + item.value.slice(-4);
                                }
                            } else if (item.code == "AGORA_EXP_TIME") {
                                this.agoraExpTime = item.value || '1800';
                            }
                        });
                    }
                })
                .catch(error => {
                    console.error('Error fetching data', error);
                });

        },
        async editSetting() {
            try {
                // Get tenant_id from JWT token
                let tenantId = null;
                try {
                    const token = localStorage.getItem('token');
                    if (token) {
                        const payload = JSON.parse(atob(token.split('.')[1]));
                        tenantId = payload.tenantId || payload.tenant_id || null;
                    }
                } catch (e) {
                    console.warn('Could not extract tenantId from token:', e);
                }

                // Handle Agora App ID: if masked (starts with ******), keep original value
                let agoraAppIdToSave = this.agoraAppId;
                if (agoraAppIdToSave && agoraAppIdToSave.startsWith('******')) {
                    // Value is masked, use original value (don't update)
                    agoraAppIdToSave = this.originalAgoraAppId || '';
                } else if (agoraAppIdToSave) {
                    // New value entered, use it
                    agoraAppIdToSave = agoraAppIdToSave.trim();
                }
                
                // Handle Agora App Certificate: if masked (starts with ******), keep original value
                let agoraAppCertificateToSave = this.agoraAppCertificate;
                if (agoraAppCertificateToSave && agoraAppCertificateToSave.startsWith('******')) {
                    // Value is masked, use original value (don't update)
                    agoraAppCertificateToSave = this.originalAgoraAppCertificate || '';
                } else if (agoraAppCertificateToSave) {
                    // New value entered, use it
                    agoraAppCertificateToSave = agoraAppCertificateToSave.trim();
                }

                const requestData = {
                    "ADMIN_MESSAGE": this.mesHafadh,
                    "PAYMENT_LINK": this.hafadhLink,
                    "FORCE_UPDATE_ANDROID": String(this.forceAndroid),
                    "FORCE_UPDATE_IOS": String(this.forceIos),
                    "MIN_VERSION_ANDROID": this.minVersionAndroid ? this.minVersionAndroid.trim() : '',
                    "MIN_VERSION_IOS": this.minVersionIos ? this.minVersionIos.trim() : '',
                    "AGORA_APP_ID": agoraAppIdToSave,
                    "AGORA_APP_CERTIFICATE": agoraAppCertificateToSave,
                    "AGORA_EXP_TIME": this.agoraExpTime ? this.agoraExpTime.trim() : '1800',
                };

                // Add tenantId if available
                if (tenantId) {
                    requestData.tenantId = tenantId;
                }

                const response = await axios.put(process.env.VUE_APP_SERVICE_URL + url.change_config,
                    requestData,
                    {
                        headers: {
                            'X-Authorization': localStorage.getItem('token'),
                        },
                    }
                );
                alert(response.data.result.mesAr);
                
                // After saving, mask the Agora values for display
                if (agoraAppIdToSave && agoraAppIdToSave.length > 4) {
                    this.agoraAppId = '******' + agoraAppIdToSave.slice(-4);
                    this.originalAgoraAppId = agoraAppIdToSave; // Update original
                }
                if (agoraAppCertificateToSave && agoraAppCertificateToSave.length > 4) {
                    this.agoraAppCertificate = '******' + agoraAppCertificateToSave.slice(-4);
                    this.originalAgoraAppCertificate = agoraAppCertificateToSave; // Update original
                }
                
                return;
            } catch (error) {
                alert('حدث خطأ ما الرجاء المحاولة مرة اخرى');
            }
        },
        handleAgoraAppIdFocus() {
            // If value is masked, clear it for editing
            if (this.agoraAppId && this.agoraAppId.startsWith('******')) {
                this.agoraAppId = '';
            }
        },
        handleAgoraAppIdBlur() {
            // If value is empty after blur, restore masked value
            if (!this.agoraAppId && this.originalAgoraAppId) {
                if (this.originalAgoraAppId.length > 4) {
                    this.agoraAppId = '******' + this.originalAgoraAppId.slice(-4);
                } else {
                    this.agoraAppId = this.originalAgoraAppId;
                }
            }
        },
        handleAgoraAppCertificateFocus() {
            // If value is masked, clear it for editing
            if (this.agoraAppCertificate && this.agoraAppCertificate.startsWith('******')) {
                this.agoraAppCertificate = '';
            }
        },
        handleAgoraAppCertificateBlur() {
            // If value is empty after blur, restore masked value
            if (!this.agoraAppCertificate && this.originalAgoraAppCertificate) {
                if (this.originalAgoraAppCertificate.length > 4) {
                    this.agoraAppCertificate = '******' + this.originalAgoraAppCertificate.slice(-4);
                } else {
                    this.agoraAppCertificate = this.originalAgoraAppCertificate;
                }
            }
        },
        async triggerDailyTracker() {
            try {
                const response = await axios.post(
                    process.env.VUE_APP_SERVICE_URL + url.trigger_daily_tracker,
                    {},
                    {
                        params: { force: true },
                        headers: { 'X-Authorization': localStorage.getItem('token') }
                    }
                );
                alert(response.data.result.mesAr);
            } catch (error) {
                if (error.response && error.response.data && error.response.data.result && error.response.data.result.mesAr) {
                    alert(error.response.data.result.mesAr);
                } else {
                    alert('خطأ في تشغيل المتتبع اليومي');
                }
            }
        }
    }
})

</script>

<style scoped>
.button {
    @apply px-4 py-2 bg-customHafadhColor text-white rounded hover:bg-customHafadhColor w-40 h-10;
}
</style>
